/**
 * Which techniques each recipe is a chance to practise.
 *
 * An explicit table rather than something derived from the steps. Guessing
 * "this recipe teaches searing" by looking for the word "sear" would be wrong
 * in both directions — it would miss the traybake, which is the best possible
 * lesson in not crowding a pan and never says so, and it would flag any recipe
 * that mentions a technique in passing.
 *
 * It lives here rather than on `Recipe` so the recipe book stays about food,
 * and so a recipe with no entry simply teaches nothing in particular.
 */

import type { TechniqueId } from "./types";

export const RECIPE_TECHNIQUES: Record<string, TechniqueId[]> = {
  "beef-cottage-cheese-bowl": ["hot-pan-sear", "dont-crowd", "season-in-layers"],
  "chicken-rice-bowl": ["hot-pan-sear", "rest-meat", "season-in-layers"],
  "teriyaki-salmon-bowl": ["dont-crowd", "reduce"],
  "burrito-bowl": ["hot-pan-sear", "even-dice", "season-in-layers"],
  "chicken-fajita-bowl": ["hot-pan-sear", "dont-crowd", "even-dice"],
  "beef-and-rice-skillet": ["hot-pan-sear", "even-dice", "season-in-layers"],
  "chicken-pasta-skillet": ["hot-pan-sear", "emulsify"],
  shakshuka: ["even-dice", "knife-grip", "reduce", "season-in-layers"],
  "veg-fried-rice": ["dont-crowd", "even-dice"],
  "chicken-traybake": ["dont-crowd", "season-in-layers"],
  "salmon-traybake": ["dont-crowd"],
  "steak-and-potatoes": ["hot-pan-sear", "rest-meat", "dont-crowd"],
  "bean-chilli": ["even-dice", "knife-grip", "reduce", "season-in-layers"],
  "lentil-curry": ["even-dice", "reduce"],
  "tofu-rice-bowl": ["hot-pan-sear", "dont-crowd"],
  "chickpea-pasta": ["emulsify", "even-dice"],
  "peanut-noodles": ["emulsify"],
  "chicken-soup": ["even-dice", "season-in-layers"],
  "lentil-soup": ["even-dice", "knife-grip", "season-in-layers"],
  "chicken-wrap": ["hot-pan-sear", "season-in-layers"],
  "protein-oats": [],
  "overnight-oats": [],
};

export function techniquesFor(recipeId: string): TechniqueId[] {
  return RECIPE_TECHNIQUES[recipeId] ?? [];
}
